export default "__VITE_PUBLIC_ASSET__fa581ac6__"